import { jsx as e, jsxs as u } from "react/jsx-runtime";
import { DropdownMenuItemMobile as p } from "../dropdown-menu-item/index.js";
import { UserImage as g } from "../account-link/user-image.js";
import o from "./styles.module.less.js";
import d from "../plus.svg.js";
import I from "../plus-hover.png.js";
import f from "../folder.svg.js";
import h from "../settings.svg.js";
import v from "../logout.svg.js";
const j = (c) => {
  const {
    getTranslation: t,
    language: n,
    handleLogout: s,
    hasNotifications: i,
    userImage: r,
    onClickUserImage: a,
    children: m
  } = c;
  return /* @__PURE__ */ e(
    p,
    {
      language: n,
      titleLabel: t("pages.account"),
      link: "account",
      classNames: {
        container: o.subMenuContainer,
        itemRow: o.itemRowClassName
      },
      items: [
        {
          title: t("account.new-case"),
          icon: /* @__PURE__ */ u("div", { className: o.newCaseWrapper, children: [
            /* @__PURE__ */ e(d, { className: o.newCaseIcon }),
            /* @__PURE__ */ e("img", { src: I, className: o.newCaseIconHover })
          ] }),
          path: "/chat?newCase=true",
          isGradient: !0
        },
        {
          title: t("account.my-cases"),
          icon: /* @__PURE__ */ e(f, { className: o.accountIcon }),
          path: "/account"
        },
        {
          title: t("account.settings"),
          icon: /* @__PURE__ */ e(h, { className: o.accountIcon }),
          path: "/account/edit"
        },
        {
          title: t("account.sign-out"),
          icon: /* @__PURE__ */ e(v, { className: o.accountIcon }),
          onClick: s
        }
      ],
      iconComponent: (l) => /* @__PURE__ */ e(
        "div",
        {
          onClick: () => a ? a(l) : void 0,
          className: o.userImageWrapper,
          children: /* @__PURE__ */ e(
            g,
            {
              userImage: r,
              hasNotifications: i
            }
          )
        }
      ),
      children: m ?? void 0
    }
  );
};
export {
  j as MobileAccountModalLink
};
